import Http from '../http'
// 平台功能模块API
export default {
  // 获取用户是否有对应的权限
  // 获取tab导航条权限
  getPrivis(params) {
    return Http.post('/index/getMenu.do', params)
  },
  // 获取二级账户列表
  getCompany() {
    return Http.post('/index/allCompany.do')
  },
  // ---------------- 围栏报警、关键点、路线偏移 begin -------------------
  // 获取围栏报警区域名称
  getFenceMarker(params) {
    return Http.post('/fence/listMarker.do', params)
  },
  // 获取围栏报警、关键点、路线偏移数据列表
  getFenceList(params) {
    return Http.post('/fence/list.do', params)
  },
  // 获取围栏报警单个设备的信息
  getSingleFenceDev(params) {
    return Http.post('/fence/get.do', params)
  },
  saveFence(params) {
    return Http.post('/fence/save.do', params)
  },
  saveFenceIssued(params) {
    return Http.post('/fence/fenceIssued.do', params)
  },
  // 删除围栏报警、关键点、路线偏移
  deleteFenceList(params) {
    return Http.post('/fence/delete.do', params)
  },
  // -------------------围栏报警、关键点、路线偏移 end ---------------------
  // ------------------- wifi下载 begin ---------------------
  // 获取wifi下载列表
  getWifiList(params) {
    return Http.post('/wifi/list.do', params)
  },
  // 获取单个wifi下载设备信息
  getSingleWifiDev(params) {
    return Http.post('/wifi/get.do', params)
  },
  // 保存wifi下载
  saveWifiDev(params) {
    return Http.post('/wifi/save.do', params)
  },
  // 删除wifi下载
  deleteWifiList(params) {
    return Http.post('/wifi/delete.do', params)
  },
  // ---------------------wifi下载 end --------------------
  // ------------------- 抓拍 begin ---------------------
  // 获取抓拍列表
  getSnapList(params) {
    return Http.post('/snap/list.do', params)
  },
  // 获取单个抓拍设备信息
  getSingleSnapDev(params) {
    return Http.post('/snap/get.do', params)
  },
  // 保存抓拍
  saveSnapDev(params) {
    return Http.post('/snap/save.do', params)
  },
  // 删除抓拍
  deleteSnapList(params) {
    return Http.post('/snap/delete.do', params)
  },
  // ---------------------抓拍 end ---------------------
  // ------------------- 录像计划 begin ----------------
  // 获取录像计划列表
  getRecordList(params) {
    return Http.post('/record/list.do', params)
  },
  // 获取单个录像计划设备信息
  getSingleRecordDev(params) {
    return Http.post('/record/get.do', params)
  },
  // 保存录像计划
  saveRecordDev(params) {
    return Http.post('/record/save.do', params)
  },
  // 删除录像计划
  deleteRecordList(params) {
    return Http.post('/record/delete.do', params)
  },
  // ---------------------录像计划 end ---------------------
  // ------------------- 维修管理 begin --------------------
  // 获取维修管理列表
  getMaintainList(params) {
    return Http.post('/vehi/list.do', params)
  },
  // 获取单个维修管理设备信息
  getSingleMaintainDev(params) {
    return Http.post('/vehi/get.do', params)
  },
  // 添加维修管理
  addMaintainDev(params) {
    return Http.post('/vehi/add.do', params)
  },
  // 保存维修管理
  saveMaintainDev(params) {
    return Http.post('/vehi/save.do', params)
  },
  // 删除维修管理
  deleteMaintainList(params) {
    return Http.post('/vehi/delete.do', params)
  },
  // 导出维修管理
  exportMaintainList() {
    return '/export/vehiList.do?'
  },
  // 导入维修管理
  importMaintainList(params) {
    // return '/vehi/importExcel.do'
    return Http.post('/vehi/importExcel.do', params)
  },
  // --------------------- 维修管理 end ---------------------
  // --------------------- 报警联动 begin ---------------------
  // 获取报警联动列表
  getAlarmActionList(params) {
    return Http.post('/alarmAction/list.do', params)
  },
  // 获取单个报警联动设备信息
  getSingleAlarmAction(params) {
    return Http.post('/alarmAction/get.do', params)
  },
  // 保存报警联动-平台
  saveAlarmAction(params) {
    return Http.post('/alarmAction/save.do', params)
  },
  // 保存报警联动-设备
  saveAlarmActionDevice(params) {
    return Http.post('/alarmAction/saveDeviceAction.do', params)
  },
  // 删除报警联动
  deleteAlarmAction(params) {
    return Http.post('/alarmAction/delete.do', params)
  },
  // 获取报警联动树状结构数据
  getAlarmActionListTree(params) {
    return Http.post('/alarmAction/devStoreList.do', params)
  },
  // --------------------- 报警联动 end ---------------------
  // --------------------- 离线升级计划 ---------------------
  // 获取离线升级计划列表
  getOfflineUpgradeList(params) {
    return Http.post('/ofl/list.do', params)
  },
  // 添加离线升级计划
  addOfflineUpgrade(params) {
    return Http.post('/ofl/save.do', params)
  },
  // 添加围栏下发计划
  addSendFence(params) {
    return Http.post('/ofl/addSendFence.do', params)
  },
  // 删除离线升级计划
  deleteOfflineUpgradeList(params) {
    return Http.post('/ofl/del.do', params)
  },
  // 获取计划详情
  getOfflineUpgradeDetail(params) {
    return Http.post('/ofl/detailed.do', params)
  },

  // ------------------- 存储服务器配置 begin ---------------------
  // 获取存储服务器配置列表
  getStorageConfigList() {
    return Http.post('/storage/list.do')
  },
  // 获取存储服务器配置列表
  saveStorageConfig(params) {
    return Http.post('/storage/save.do', params)
  },
  // --------------------- 文本下发 ---------------------
  // 获取文本下发列表
  getTextDeliveryList(params) {
    return Http.post('/cyy/getList.do', params)
  },
  // 删除文本下发
  deleteTextDeliveryList(params) {
    return Http.post('/cyy/del.do', params)
  },
  // 添加文本下发
  addTextDeliveryList(params) {
    return Http.post('/cyy/save.do', params)
  },
  // 修改文本下发
  editTextDeliveryList(params) {
    return Http.post('/cyy/update.do', params)
  },
  // 获取单个文本下发
  getSingleTextDelivery(params) {
    return Http.post('/cyy/getInfo.do', params)
  },
  // ------------------- 车辆运营状态报备 begin --------------------
  // 获取车辆运营状态报备管理列表
  getVehiOperList(params) {
    return Http.post('/oper/operlist.do', params)
  },
  // 获取单个车辆运营状态报备管理设备信息
  getVehiOperInfo(params) {
    return Http.post('/oper/getInfo.do', params)
  },
  // 添加车辆运营状态报备管理
  vehiOperAdd(params) {
    return Http.post('/oper/add.do', params)
  },
  // 保存车辆运营状态报备管理
  vehiOperSave(params) {
    return Http.post('/oper/save.do', params)
  },
  // 删除车辆运营状态报备管理
  vehiOperDelete(params) {
    return Http.post('/oper/delete.do', params)
  },
  // 导出车辆运营状态报备管理
  exportVehiOperList() {
    return '/export/operlist.do?'
  }
}



// WEBPACK FOOTER //
// ./src/services/api/platform.js